import React, { useState, useRef, useContext } from 'react';
import PasswordForm from './PasswordForm'
import {FormProvider} from '@thinkwell/react.common'
import {EditModal} from '@thinkwell/react.polaris'
import {HostContext} from './contexts/Host'

export default function EditPassword(props) {
  const host = useContext(HostContext)
  return (
    <FormProvider><EditModal
      setSavingRef={props.setSavingRef}
      onSave={props.onSave}
      url={props.forAccount ? `${host}/accounts/${props.id}/password?shop_name=${props.shop_name}` : `/admin/customers/${props.id}/password`}
      title="Change Password">
      <PasswordForm withConfirmation />
    </EditModal></FormProvider>
  );
}
